/**
 * Current user reducer for the Flux/Redux skeleton.
 */

import { createSlice } from '@reduxjs/toolkit';
import { fetchCurrentUser } from '../actions/userThunks';
import { UserResponse } from '../../@types/user';

export interface UserState {
    current: {
        data: UserResponse | null;
        isLoading: boolean;
        error: string | null;
    }
};

const initialState: UserState = {
    current: {
        data: null,
        isLoading: false,
        error: null,
    }
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCurrentUser.pending, (state) => {
                state.current.isLoading = true;
                state.current.error = null;
            })
            .addCase(fetchCurrentUser.fulfilled, (state, action) => {
                state.current.isLoading = false;
                state.current.data = action.payload;
                state.current.error = null;
            })
            .addCase(fetchCurrentUser.rejected, (state, action) => {
                state.current.isLoading = false;
                state.current.error = action.error.message ?? 'Failed to fetch current user';
            });
    },
});

export const userReducer = userSlice.reducer;
